import { Component, OnInit} from '@angular/core';
import { OtpService } from '../services/otp.service';
import { OtpCountdownService } from '../services/otp-countdown.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { Guid } from 'guid-typescript';
import { RegistrationRoutingService } from '../services/registration-routing.service';
import { Validators, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UserAuthService } from '../services/user-auth.service';
import { Subject, Subscription } from 'rxjs';
import { CampaignService } from '../services/campaign.service';
import { DataLayerService } from '../services/datalayer.service';
import { SapiService } from '../services/sapi.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule, CurrencyPipe, NgIf } from '@angular/common';
import { NumericFieldDirective } from '../helpers/directive/numeric-field.directive';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { FormatimePipe } from '../helpers/pipe/formatime.pipe';
import { FooterComponent } from '../shared/footer.component';
import { HeaderComponent } from '../shared/header.component';
import { LogoComponent } from '../logo/logo.component';
import { NeedHelpComponent } from '../shared/need-help.component';



@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css'],
  host: {'class': 'd-flex flex-column h-100 ipadfooterbottom'},
  standalone: true,
  imports: [
      TrackingDirective,
      RouterLink,
      NgIf,
      FormsModule,
      ReactiveFormsModule,
      NumericFieldDirective,
      CurrencyPipe,
      FormatimePipe,
      CommonModule,
      FooterComponent,
      HeaderComponent,LogoComponent,NeedHelpComponent
  ],
})
export class OtpComponent implements OnInit {
  private get otpWindowMs(): number {
    return environment.otpPolicy.sessionLifespanMinutes * 60 * 1000;
  }

  private get resendUnlockThreshold(): number {
    return environment.otpPolicy.firstOtpExpiryMinutes * 60 - environment.otpPolicy.resendAfterSeconds;
  }

  otpForm;
  otp: string;
  otpErrorMsg = '';
  sendOtpText = 'Send SMS OTP';
  sendEmailOtpText = 'Send Email OTP';
  otpPopupHeaderText = 'Get your One-Time Pin (OTP) via SMS';
  btnOTPIsDisabled = false;
  usedOtpType;
  showSendOTPSection = true;
  showOtpValidateSection = false;
  successMsg = '';
  errorMsg = '';
  phoneNumber = '';
  basicInfoVerifyConfirmed: any;
  WebSource = '';
  numberMasking = '';
  time;
  userActivity;
  userInactive: Subject<any> = new Subject();
  campaignCookieName: string="user_campaign";
  sapiVisitErrorMsg: string;
  sapiurl: SafeResourceUrl;

  disableOTPSendButton: boolean = false;
  secondsLeft: number = 0;
  countDown: number = 30;
  hideResendOTPButton: boolean = false;
  optSessionStillValid: boolean = false;
  otpSentSuccesfully: number;
  numbersubs: Subscription;
  sessionTimeOut: Subscription;
  isNumberSubSubscribed: boolean = false;
  isSessionTimeOutSubscribed: boolean = false;
  counter : number;
  tick = 1000;
  successMsgWithPipe: boolean = false;
  otpSessionTimeOutInterval;
  otpSession10MinInterval;
  resendAvailable: boolean = null;

  numbersubs2: Subscription;
  isNumberSub2Subscribed: boolean = false;
  secLeftResendAllowed: number;
  domainWithProtocol : string;
  ischatbotSQConfirmed: boolean = false;

  constructor(
    private readonly otpService: OtpService,
    private readonly otpCountdownService: OtpCountdownService,
    public readonly router: Router,
    private readonly spinner: NgxSpinnerService,
    private readonly cookieService: CookieService,
    private readonly oauthService: OAuthService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly registrationRouting: RegistrationRoutingService,
    private readonly formBuilder: FormBuilder,
    private readonly userAuthService: UserAuthService,
    private readonly campaignService: CampaignService,
    private readonly dataLayerService: DataLayerService,
    private readonly sapiService: SapiService
  ) {

    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        if (params.websource || params.WebSource ||
          params.WEBSOURCE || params.webSource) {
          this.WebSource = params.websource || params.WebSource || params.WEBSOURCE || params.webSource;
        }
      }
    });
    }


  ngOnInit() {
    this.domainWithProtocol = globalThis.location.origin;   
    const tempToken = localStorage.getItem('tempToken');
    if (tempToken!= null && tempToken!='')
    {
      this.otpForm = this.formBuilder.group({
        OtpOne: ['', [Validators.required, Validators.minLength(1)]],
        OtpTwo: ['', [Validators.required, Validators.minLength(1)]],
        OtpThree: ['', [Validators.required, Validators.minLength(1)]],
        OtpFour: ['', [Validators.required, Validators.minLength(1)]],
        OtpFive: ['', [Validators.required, Validators.minLength(1)]],
        OtpSix: ['', [Validators.required, Validators.minLength(1)]],
      });
      this.phoneNumber = localStorage.getItem('number');

      this.basicInfoVerifyConfirmed = JSON.parse(localStorage.getItem('verification'));


    }
    else{
      this.userAuthService.logoutActiveUser(globalThis.location.origin + '/register');
      this.router.navigate(['/register']);
  }
  }

  get otpFormControls() { return this.otpForm.controls; }

 

  stopTimer() {
    clearTimeout(this.time);
    this.time = 'stop';
    console.log('Timer Stop');
    console.log(this.time);
  }

  getOtpElement(index) {
    return <HTMLInputElement>document.getElementById('otp' + index);
  }
  onKeyUpEvent(event, index) {
    const eventCode = event.which || event.keyCode;
    if (event.target.value.length === 1) {
      if (index !== 6) {
        this.getOtpElement(index + 1).focus();
      } else {
        this.getOtpElement(index).blur();
        // Final otp
        this.otp = this.getOtpElement(1).value + this.getOtpElement(2).value + this.getOtpElement(3).value + this.getOtpElement(4).value + this.getOtpElement(5).value + this.getOtpElement(6).value;
        if(index===6)
        {
          if (event.keyCode === 13) {
           this.validateOtp();
           this.userInactive.unsubscribe();
            // rest of your code
          }

        }
 
      }
    }
    else if (event.target.value.length > 1) {
      this.getOtpElement(index).value = '';
    }
    if (eventCode === 8 && index !== 1) {
      this.getOtpElement(index - 1).focus();
    }
  }


  onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const currentElement = this.getOtpElement(item);
      if (!currentElement.value) {
        currentElement.focus();
        break;
      }
    }
  }

  sendOtp(otpType, message) {
    this.otpErrorMsg = '';
    const param = {
      OtpType: otpType,
    };
    this.basicInfoVerifyConfirmed = JSON.parse(localStorage.getItem('verification'));
    console.log('check value in otp page'+ this.basicInfoVerifyConfirmed);
    this.usedOtpType = otpType;

    this.otpService.sendOtp(param).subscribe({
      next: (data: any) => this.handleSendOtpSuccess(data, message),
      error: (err: HttpErrorResponse) => this.handleSendOtpError(err)
    });
  }

  private maskPhoneNumber(): string {
    const hiddenPart = this.phoneNumber.slice(2, this.phoneNumber.length - 3);
    return this.phoneNumber.replace(hiddenPart, hiddenPart.replace(/./g, "*"));
  }

  private handleSendOtpSuccess(data: any, message: string) {
    this.applySendOtpMessage(message);

    if (data.sendOtpStatusType.status !== 200) {
      return;
    }

    if (data.sendOtpStatusType.message === "SecondOTPSent") {
      this.hideResendOTPButton = true;
      this.resendAvailable = false;
    }
    if (data.sendOtpStatusType.message === "Sent") {
      this.otpCountdownService.handleOtpSent(this);
    }

    this.scheduleSendOtpSessionTimeout();
    this.applyResendTextState();

    if (data.sendOtpStatusType.status === 202) {
      this.otpErrorMsg = 'OTP already verified, please try later.';
    }
  }

  private applySendOtpMessage(message: string) {
    if (message == "otpSent") {
      this.numberMasking = this.maskPhoneNumber();
      this.showSendOTPSection = false;
      this.showOtpValidateSection = true;
    }
    //Added time just to check the second time otp resend after time otp
    else if (message == "otpReSent") {
      this.successMsg = 'Resend SMS OTP sent successfully';
      setTimeout(() => {
        this.successMsg = '';
      }, 5000);
    }
  }

  private scheduleSendOtpSessionTimeout() {
    if (this.otpSession10MinInterval) {
      return;
    }

    this.otpSession10MinInterval = setTimeout(() => {
      this.successMsgWithPipe = false;

      if (this.isSessionTimeOutSubscribed) {
        this.sessionTimeOut.unsubscribe();
      }
      this.errorMsg = 'Your session has timed-out. Please try to register again.';
      localStorage.setItem('errorMsg', this.errorMsg);
      setTimeout(() => {
        this.router.navigateByUrl('register');
      }, 300);
    }, this.otpWindowMs);
  }

  private applyResendTextState() {
    if (this.sendOtpText === 'Resend SMS OTP') {
      this.successMsg = 'Resend OTP sent successfully';
      this.disableOTPSendButton = true;
      this.hideResendOTPButton = true;
      setTimeout(() => {
        this.successMsg = '';
      }, 3000);
    }
    this.sendOtpText = 'Resend SMS OTP';
  }

  private handleSendOtpError(err: HttpErrorResponse) {
    if (err.error.sendOtpStatusType.status === 421) {
      this.handleOtpAlreadySentError(err);
    }
    else if (err.error.sendOtpStatusType.status === 429) {
      this.otpErrorMsg = 'OTP failed, please try again.';
    }
    else {
      this.otpErrorMsg = 'Please contact admin';
    }
  }

  private handleOtpAlreadySentError(err: HttpErrorResponse) {
    if (err.error.sendOtpStatusType.sessionTimeOut > 0) {
      this.applyOtpAlreadySentState(err);
    }
    else {
      this.otpErrorMsg = "OTP Already Sent. Please try after later";
    }
  }

  private applyOtpAlreadySentState(err: HttpErrorResponse) {
    this.sendOtpText = "Resend SMS OTP";
    this.showSendOTPSection = false;
    this.showOtpValidateSection = true;
    this.numberMasking = this.maskPhoneNumber();
    this.optSessionStillValid = true;
    this.secLeftResendAllowed = err.error.sendOtpStatusType.sessionTimeOut - this.resendUnlockThreshold;

    if (this.secLeftResendAllowed > 0) {
      this.otpCountdownService.startSecLeftCountdown(this);
      this.hideResendOTPButton = false;
      this.successMsgWithPipe = false;
    } else {
      this.hideResendOTPButton = true;
      this.scheduleOtpSessionTimeoutCountdown(err);
    }

    this.optSessionStillValid = true;
  }

  private scheduleOtpSessionTimeoutCountdown(err: HttpErrorResponse) {
    this.otpSessionTimeOutInterval = setTimeout(() => {
      this.counter = err.error.sendOtpStatusType.sessionTimeOut;
      this.sessionTimeOut = this.otpCountdownService.startCounter(
        this.counter,
        this.tick,
        (value) => {
          this.counter = value;
          this.successMsgWithPipe = true;
        },
        () => this.router.navigateByUrl('register')
      );

      this.successMsg = '';
    }, 2000);
  }

  validateOtp() {
    if (this.btnOTPIsDisabled) {
      return;
    }
    this.btnOTPIsDisabled = true;
    this.otpErrorMsg = '';
    if (this.otpForm.invalid) {
      this.otpForm.markAllAsTouched();
      this.btnOTPIsDisabled = false;
      return;
    }
    this.spinner.show();

    const param = {
      Otp: this.otpForm.value.OtpOne + this.otpForm.value.OtpTwo + this.otpForm.value.OtpThree + this.otpForm.value.OtpFour + this.otpForm.value.OtpFive+ this.otpForm.value.OtpSix,
      OtpType: this.usedOtpType,

    };
    console.log('OTPvalue'+ param.Otp);
    this.otpService.validateOtp(param).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.btnOTPIsDisabled = false;
        this.basicInfoVerifyConfirmed =  JSON.parse(localStorage.getItem('verification'));
        this.ischatbotSQConfirmed = JSON.parse(localStorage.getItem('ischatbotSQConfirmed'));
        this.resetOtpToDefault();
  
        setTimeout(() => {
          // now check if verify ok and otp ok no need for open security question
          if (this.basicInfoVerifyConfirmed === false && this.ischatbotSQConfirmed === false) {
          //  this.openSecurityQuestions();
            this.sapiCreateVisitForSQ();
            // this.openSecurityQuestionsPopup();
          }
          else {
            this.dataLayerService.dataLayerCallback(true,'New User Register Successfully',sessionStorage.getItem('userEmail'),sessionStorage.getItem('userPhoneNumber'))
            { this.login(); }
          }
        }, 500);
      },
      error: (err: HttpErrorResponse) => {
        this.spinner.hide();
      this.btnOTPIsDisabled = false;
      if (err.status === 422) {
        this.otpErrorMsg = 'Incorrect OTP';
        setTimeout(() => {
            this.otpErrorMsg = '';
          }, 3000);
        }
        else if(err.status === 403){
          this.otpErrorMsg = "OTP session has expired, please try later.";
          this.resetOtpToDefault();
          setTimeout(() => {
            this.router.navigateByUrl('register');
          }, 5000);


        }else{
          this.otpErrorMsg = 'Please contact admin';
        }
      }
    });
  }


  resetOtpToDefault(){
    if(this.otpSession10MinInterval != undefined){
      clearTimeout(this.otpSession10MinInterval);
      this.otpSession10MinInterval = undefined;
    }
    if(this.otpSessionTimeOutInterval != undefined){
      clearTimeout(this.otpSessionTimeOutInterval);
    }
    if(this.isSessionTimeOutSubscribed){
      this.successMsgWithPipe = false;
      this.sessionTimeOut.unsubscribe();
    }
    if(this.isNumberSubSubscribed)
    {
      this.numbersubs.unsubscribe();
    }

    if(this.isNumberSub2Subscribed)
      {
        this.numbersubs2.unsubscribe();
      }
    this.successMsgWithPipe = false;
    this.optSessionStillValid = null;

  }

  openSecurityQuestions() {
    globalThis.clearTimeout(this.userActivity);
    localStorage.setItem('RegisterUrl', '/register');
    if (this.WebSource) {
      this.router.navigateByUrl('/security-question' + this.registrationRouting.queryStringParams());
    }
    else {
      this.router.navigate(['/security-question']);
    }
  }

  login() {
    this.spinner.show();
    this.azureAdlogin(true);
  }

  azureAdlogin(isRegistrationSuccess: boolean) {
    localStorage.removeItem('tempToken');
    let submissionId = '';
    let submissionCode = Guid.create().toString();
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }

    if (isRegistrationSuccess) {
      submissionCode = '0df6b091-5d71-4f75-a6df-2d6a016e3709';
    }

    Guid.create().toString()

    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {
      this.campaignService.getActiveCampaign("", campaignCookie).subscribe((data: any) => {
           const tileHighlightId = data.tileHighlightId || '';
                const highlightParts: string[] = tileHighlightId ? tileHighlightId.split("#") : ['', ''];
                const highlightParam1 = highlightParts[0] || '';
                const highlightParam2 = highlightParts[1] || '';
                sessionStorage.setItem("productId",highlightParam1)
                sessionStorage.setItem("categoryId",highlightParam2)
        this.oauthService.initLoginFlow('', {
          submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
          instrumentationKey: environment.appInsights.instrumentationKey,
          utm_id: data.campaignUtmId
        });
      }, (err: HttpErrorResponse) => console.log(err));

    }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }
  }

  azureActivelogin() {
    let submissionId = '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();
  }


  OtPFormReset() {
    this.otpForm.reset();
    this.otpForm.markAsUntouched();
  }

  sapiCreateVisitForSQ(){
    localStorage.setItem('RegisterUrl', '/register');
    console.log("Create Visit from SAPI Called");
    this.spinner.show();
    setTimeout(() => {
    const param = { returnUrl:  this.domainWithProtocol +'/sq-redirect'};
    
    this.sapiService.createSAPIVisitForSecurityQuestions(param).subscribe((data: any) => {
      if (data != null) {
        if (data.statusCode == 302 && data.returnUrl != '' && data.returnUrl != null) {
          console.log("SAPI SQ - ", data.returnUrl);
          localStorage.setItem("SapiVisitUrl", data.returnUrl);
          this.openSecurityQuestions();
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.sapiVisitErrorMsg = err.error;
      });
      this.spinner.hide();
      }, 100);
  }

  monitorOtpAutofill(event: Event) {
    let otpInput = event.target as HTMLInputElement;
    let otp = otpInput.value.trim();
  
    if (otp.length === 6) {
      otpInput.value = ""; 
      this.fillOtpFields(otp);
    }
  }
  
  
  fillOtpFields(otp: string) {
    let inputs = document.querySelectorAll<HTMLInputElement>(".passcode-wrapper input");
  
    if (otp.length !== 6) {
     
      return;
    }
  
    for (let i = 0; i < inputs.length; i++) {
      if (otp[i]) {
         
        inputs[i].value = otp[i];
  
        // Update Angular form control
        let formControlName = inputs[i].getAttribute("formControlName");
        if (formControlName && this.otpForm.controls[formControlName]) {
          this.otpForm.controls[formControlName].setValue(otp[i]);
          this.otpForm.controls[formControlName].markAsTouched();
        }
      }
    }
  
    // Move focus to the last input
    inputs[inputs.length - 1].focus();
  }

}
